import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">Guijs Consultancy</h3>
            <p className="text-gray-400 mb-4">
              Specialist in Zoho CRM implementaties en automatisering voor bedrijven die willen groeien.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition-colors duration-200"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-blue-500 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/diensten" className="hover:text-blue-500 transition-colors duration-200">
                  Diensten
                </Link>
              </li>
              <li>
                <Link to="/zoho-partner" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho Partner
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-500 transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Zoho Producten */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Zoho Producten</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/zoho-one" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho One
                </Link>
              </li>
              <li>
                <Link to="/zoho-crm" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho CRM
                </Link>
              </li>
              <li>
                <Link to="/zoho-desk" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho Desk
                </Link>
              </li>
              <li>
                <Link to="/zoho-books" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho Books
                </Link>
              </li>
              <li>
                <Link to="/zoho-projects" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho Projects
                </Link>
              </li>
              <li>
                <Link to="/zoho-people" className="hover:text-blue-500 transition-colors duration-200">
                  Zoho People
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  Javalaan 7<br />
                  3742 CN Baarn<br />
                  Nederland
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-500 flex-shrink-0" />
                <a href="tel:0638823471" className="hover:text-blue-500 transition-colors duration-200">
                  06 3882 3471
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-500 flex-shrink-0" />
                <a href="mailto:aanvragen@crm-systemen.nl" className="hover:text-blue-500 transition-colors duration-200">
                  aanvragen@crm-systemen.nl
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} Guijs Consultancy. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
